<script>
import candidateWizardApi from '@api/candidateWizard'

export default {

  props: {
    withProfile: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      candidate: null,
      profile: null,
      loading: true,
      error: ''
    }
  },

  created() {
    this.fetchCandidate()

    if (this.withProfile) {
      this.fetchProfile()
    }
  },

  methods: {
    fetchCandidate() {
      this.error = ''
      this.loading = true
      return candidateWizardApi.show()
        .then(response => {
          this.loading = false
          this.candidate = response
        })
        .catch(() => {
          this.loading = false
          this.error = 'We could not load your candidate details. Check your connection or reopen your invitation, then try again.'
        })
    },

    fetchProfile() {
      return candidateWizardApi.fetchProfile()
        .then(response => {
          this.loading = false
          this.profile = response
        })
        .catch(() => {
          this.loading = false
          this.error = 'We could not load your candidate details. Check your connection or reopen your invitation, then try again.'
        })
    }
  },

  render(h) {
    if (this.error) {
      return h('div', { attrs: { role: 'alert' }, class: 'p-6' }, [h('p', this.error), h('button', {
        class: 'accessible-button underline mt-4', on: { click: () => { this.fetchCandidate(); if (this.withProfile) { this.fetchProfile() } } }
      }, 'Try again')])
    }
    return this.$scopedSlots.default({
      candidate: this.candidate,
      profile: this.profile,
      loading: this.loading
    })
  }
}
</script>
